module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/author.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('span', {
    staticClass: "blub"
  }, [_vm._v("Sarah-Jane Hicks")]), _vm._v(" has always enjoyed crochet and crafting in her spare time. She was taught to crochet as a child by her mum and nan. Previously she worked as a tax adviser and is now a freelance crochet designer. She has had patterns published in various popular craft and crochet magazines. She has over 42K followers on her Instagram account: "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/flo_and_dot/",
      "target": "_blank"
    }
  }, [_vm._v("@flo_and_dot")]), _vm._v(", and her blog can be seen at: "), _c('a', {
    attrs: {
      "href": "http://floanddot.blogspot.com",
      "target": "_blank"
    }
  }, [_vm._v("floanddot.blogspot.com")]), _vm._v(". Sarah-Jane lives in Norfolk in the UK.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fm01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6857633b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Author.vue
// module id = 57
// module chunks = 0